"use client";
import React from "react";
import styles from "../css/components/paymentfield.module.css";

export default function PaymentField({ details }) {
  return (
    <div className={styles.paymentCard}>
      {/* Dynamically render each field if it exists */}
      {details.priceTitle && (
        <div className={styles.row}>
          <span className={styles.label}>{details.priceTitle}</span>
          <span className={styles.value}>{details.price || "R0.00"}</span>
        </div>
      )}

      {details.feeTitle && (
        <div className={styles.row}>
          <span className={styles.label}>{details.feeTitle}</span>
          <span className={styles.value}>{details.fee || "R0.00"}</span>
        </div>
      )}

      {details.coPayTitle && (
        <div className={styles.row}>
          <span className={styles.label}>{details.coPayTitle}</span>
          <span className={styles.value}>{details.coPay || "R0.00"}</span>
        </div>
      )}

      {details.grossTitle && (
        <div className={`${styles.row} ${styles.grossRow}`}>
          <span className={styles.label}>{details.grossTitle}</span>
          <span className={styles.value}>{details.gross || "R0.00"}</span>
        </div>
      )}

      {details.savingsTitle && (
        <div className={styles.row}>
          <span className={styles.label}>{details.savingsTitle}</span>
          <span className={styles.value}>{details.savingsValue || "R0.00"}</span>
        </div>
      )}

      {details.mrpTitle && (
        <div className={styles.row}>
          <span className={styles.label}>{details.mrpTitle}</span>
          <span className={styles.value}>{details.mrp || "R0.00"}</span>
        </div>
      )}
    </div>
  );
}
